import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PromotionMedias from "@/components/preKYC/PromotionMedias";
import defaultValues from "@/constant/defaultValues";
import PreKYCIndustry from "@/pages/Charts/PreKYCIndustry";
import MapWithPinBullets from "@/pages/admin/preKYC/MapWithPinBullets";
import { useAuth } from "@/AuthProvider";
import InquiryCount from "@/components/inquiry/InquiryCount";
import NewsBlog from "@/components/preKYC/NewsBlog";
import { getNewsBlogList } from "@/actions/defaultDataAction";
const PrekycDashboard = (props) => {

    const [industries, setIndustries] = useState([]);
    const { user, isDemoUser } = useAuth();
    const [newsData, setNewsData] = useState([]);


    const getNewsDashboardData = async () => {
        try {
            await props.getNewsData().then((response) => {
                setNewsData(response.data);
            }).catch((err) => {
                console.log("Error fetching data:", err);
            });
        } catch (err) {
            console.log("Error ==== ", err);
        }
    };

    useEffect(() => {
        let iData = defaultValues.DUMMY_INDUSTRIES;

        const options = iData.map((r) => ({
            tooltipText: r.industry_name && r.industry_name.length > 200 ? r.industry_name.slice(0, 200) + '...' : r.industry_name || 'No Data',
            category: r.industry_name,
            value: r.per_count,
        }));
        setIndustries(options);

    }, []);

    useEffect(() => {
        getNewsDashboardData();
    }, []);

    return (<>
        <div className={!isDemoUser ? 'new-design dashboard-page' : ''}>

            <div className="dashboart-chart">
                {isDemoUser ? (
                    <>
                        <div className='dashbord-welcom-text mb-3'>
                            <p >Welcome, <span className=''>
                                {user && user.name}
                            </span>👋🏻</p>
                        </div>
                        <div className="row mb-3 dashboart-chart-banner">
                            <div className={"col-md-10"}>
                                <div className="card card-shadow border-0 ">
                                    <PromotionMedias title="Newly Joined Partners" />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <InquiryCount />
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-lg-6 col-md-12 col-sm-12" >
                                <div className="card card-shadow border-0" >
                                    <PreKYCIndustry title="Trending Industries" data={industries} />
                                </div>

                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12" >
                                <div className="card card-shadow border-0" >
                                    <MapWithPinBullets title="World Wide Buyers/Suppliers across (80+) Countries" />
                                </div>

                            </div>
                        </div>
                    </>

                ) : (
                    <div className='container-fluid'>
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className='dashbord-welcom-text'>
                                    <p >Welcome, <span className=''>
                                        {user && user.name}
                                    </span>👋🏻</p>
                                </div>
                            </div>
                        </div>

                        <div className="row dashboart-chart-banner">
                            <div className="col-xxl-8 col-xl-12 col-lg-12">
                                <div className='card p-0'>
                                    <PromotionMedias title="Newly Joined Partners" />
                                </div>
                            </div>

                            <div className="col-xxl-4 col-xl-12 col-lg-12">
                                <div className='container card'>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <NewsBlog newsData={newsData} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className='row dashboart-chart-banner'>
                            <div className="col-md-12" >
                                <div className='row'>
                                    <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12" >
                                        <div className='card'>
                                            <PreKYCIndustry title="Trending Industries" data={industries} />
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 col-xl-12 col-lg-12 col-md-12" >
                                        <div className='card'>
                                            <MapWithPinBullets title="World Wide Buyers/Suppliers across (80+) Countries" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>

    </>)
}

const mapStateToProps = (state) => {
    return {
        // console.log('state================>', state);
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getNewsData: () => dispatch(getNewsBlogList())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrekycDashboard);